import { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";
import { getHandlingUnitTypeInfo } from "@/Data/getHandlingUnitTypeInfo";

export function getPluralFormForHandlingUnitType(
  handlingUnitType: HandlingUnitType,
) {
  const item = getHandlingUnitTypeInfo(handlingUnitType);

  return item.plural;
}
